import { Features } from "@KassaroAB/shared/types/enums/Features";

export type CatalogSidebarLink = {
  to: string;
  label: string;
  features?: Features[];
};

export const catalogSidebarLinks: CatalogSidebarLink[] = [
  { to: "catalog/products", label: "catalog.products" },
  { to: "catalog/productGroups", label: "catalog.productGroups", features: [Features.GROUPS] },
  { to: "catalog/units", label: "catalog.units" },
  { to: "catalog/courses", label: "catalog.courses", features: [Features.PREP_TICKETS] },
  { to: "catalog/prepStations", label: "catalog.prepStations", features: [Features.PREP_TICKETS] },
  { to: "catalog/modifiers", label: "catalog.modifiers", features: [Features.MODIFIERS] },
  { to: "catalog/modifierGroups", label: "catalog.modifierGroups", features: [Features.MODIFIERS] },
  { to: "catalog/bookkeepingAccounts", label: "catalog.bookkeepingAccounts" },
  { to: "catalog/offers", label: "catalog.offers", features: [Features.OFFERS] },
  { to: "catalog/suppliers", label: "catalog.suppliers", features: [Features.SUPPLIERS] },
  { to: "catalog/layouts", label: "catalog.layouts", features: [Features.LAYOUTS] },
];
